export default function Map() {
  return <div style={{ minHeight: window.innerHeight - 100 }}>Map</div>;
}
